(function(){
  if ((window.__cfLoaded = window.__cfLoaded || {})['cf-picker']) return;
  window.__cfLoaded['cf-picker'] = true;
const CATALOGUE_TILES = [
  { tileId: "TQ3080", handle: null, lat: 51.505, lng: -0.124, place: "London", locality: "" },
  { tileId: "NT2573", handle: null, lat: 55.953, lng: -3.189, place: "Edinburgh", locality: "" },
  { tileId: "NS5865", handle: null, lat: 55.86, lng: -4.252, place: "Glasgow", locality: "" },
  { tileId: "SP0687", handle: "birmingham-centenarysquare", lat: 52.48, lng: -1.91, place: "Birmingham", locality: "Centenary Square" },
  { tileId: "TL4457", handle: "cambridge", lat: 52.198, lng: 0.139, place: "Cambridge", locality: "" },
  { tileId: "NZ2742", handle: "durham", lat: 54.667, lng: -1.75, place: "Durham", locality: "" },
  { tileId: "NT2473", handle: "edinburgh-castle", lat: 55.949, lng: -3.2, place: "Edinburgh", locality: "Castle" },
  { tileId: "TQ3779", handle: "greaterlondon-canarywharf", lat: 51.505, lng: -0.019, place: "Greater London", locality: "Canary Wharf" },
  { tileId: "TA0928", handle: "hull", lat: 53.762, lng: -0.33, place: "Kingston upon Hull", locality: "" },
  { tileId: "SJ8398", handle: "deansgate", lat: 53.474, lng: -2.251, place: "Manchester", locality: "Deansgate" },
  { tileId: "SU7173", handle: "reading-ictower", lat: 51.459, lng: -0.962, place: "Reading", locality: "IC Tower" },
  { tileId: "SJ8099", handle: "salfordquays-mediacityuk", lat: 53.472, lng: -2.294, place: "Salford", locality: "Quays \xB7 MediaCityUK" },
  { tileId: "SK3587", handle: "sheffield-citycentre", lat: 53.38, lng: -1.464, place: "Sheffield", locality: "" },
  { tileId: "SK3585", handle: "sheffield-moorhead", lat: 53.38, lng: -1.47, place: "Sheffield", locality: "Moor Head" },
  { tileId: "SK3489", handle: "sheffield-neepsend", lat: 53.387, lng: -1.474, place: "Sheffield", locality: "Neepsend" },
  { tileId: "SK3486", handle: "sheffieldecclesallroad-botanicalgardens", lat: 53.373, lng: -1.492, place: "Sheffield", locality: "Ecclesall Road" },
  { tileId: "NZ8911", handle: "whitby", lat: 54.489, lng: -0.614, place: "Whitby", locality: "" },
  { tileId: "SE6051", handle: "york", lat: 53.966, lng: -1.074, place: "York", locality: "" }
];
const POPULAR_PICKS = [
  { tileId: "SK3587", place: "Sheffield" },
  { tileId: "SE6051", place: "York" },
  { tileId: "NT2473", place: "Edinburgh Castle" },
  { tileId: "NZ2742", place: "Durham" },
  { tileId: "SJ8398", place: "Manchester" },
  { tileId: "TL4457", place: "Cambridge" }
];
const EXAMPLE_CARDS = [
  { tileId: "SK3587", place: "Sheffield", locality: "", line: "A steel-city centre \u2014 Don, Sheaf, and the Botanical hill" },
  { tileId: "NT2473", place: "Edinburgh", locality: "Castle", line: "Volcanic crag at the head of the Royal Mile" },
  { tileId: "NZ8911", place: "Whitby", locality: "", line: "The Esk estuary, abbey ruins, and 199 steps" }
];
function fmtPickerCoord(lat, lng) {
  return `${Math.abs(lat).toFixed(3)}\xB0 ${lat >= 0 ? "N" : "S"} \xB7 ${Math.abs(lng).toFixed(3)}\xB0 ${lng >= 0 ? "E" : "W"}`;
}
const CORS_PROXY_BASE = "https://gen.cityform.co.uk/api/r?url=";
function proxied(url) {
  return url ? CORS_PROXY_BASE + encodeURIComponent(url) : url;
}
function resolveTileAssets(tile, manifest) {
  if (!tile) return null;
  if (tile.handle) {
    const cfp = typeof window !== "undefined" && window.cfPaths || {};
    const prod = cfp.products && cfp.products[tile.handle] || null;
    if (prod && prod.glb) {
      return {
        glb: prod.glb,
        usdz: prod.usdz || null,
        qr: prod.qr || null,
        preview: null,
        title: prod.title || tile.place.toUpperCase(),
        subline: prod.subline || (tile.locality ? tile.locality.toUpperCase() : ""),
        coord: prod.coord || fmtPickerCoord(tile.lat, tile.lng)
      };
    }
  }
  if (manifest && manifest.tiles && manifest.tiles[tile.tileId]) {
    const t = manifest.tiles[tile.tileId];
    if (t.glb) {
      const urlFor = (filename) => {
        if (manifest.schema_version >= 2 && t.release_tag) {
          return proxied(`${manifest.base_url}/${t.release_tag}/${filename}`);
        }
        return proxied(`${manifest.base_url}/${filename}`);
      };
      return {
        glb: urlFor(t.glb),
        usdz: null,
        qr: null,
        preview: t.preview ? urlFor(t.preview) : null,
        title: tile.place.toUpperCase(),
        subline: tile.locality ? tile.locality.toUpperCase() : "",
        coord: fmtPickerCoord(tile.lat, tile.lng),
        isBeta: true
      };
    }
  }
  return null;
}
async function reverseGeocode(lat, lng) {
  try {
    const url = `https://nominatim.openstreetmap.org/reverse?format=jsonv2&lat=${lat}&lon=${lng}&zoom=16&addressdetails=1`;
    const r = await fetch(url, {
      headers: { "Accept-Language": "en-GB" },
      cache: "force-cache"
    });
    if (!r.ok) return null;
    const d = await r.json();
    if (!d || !d.address) return d && d.display_name ? d.display_name : null;
    const a = d.address;
    const primary = a.attraction || a.tourism || a.historic || a.amenity || a.building || a.road || a.suburb || a.neighbourhood || a.hamlet || a.village;
    const city = a.city || a.town || a.village || a.county || "";
    return primary && city && primary !== city ? `${primary}, ${city}` : primary || city || null;
  } catch (e) {
    return null;
  }
}
async function geocodePostcode(postcode) {
  const q = postcode.trim().replace(/\s+/g, " ").toUpperCase();
  if (!q) return null;
  try {
    const url = `https://nominatim.openstreetmap.org/search?format=jsonv2&q=${encodeURIComponent(q)}&countrycodes=gb&limit=1&addressdetails=1`;
    const r = await fetch(url, {
      headers: { "Accept-Language": "en-GB" },
      cache: "force-cache"
    });
    if (!r.ok) return null;
    const arr = await r.json();
    if (!arr || !arr.length) return null;
    return { lat: parseFloat(arr[0].lat), lng: parseFloat(arr[0].lon), label: arr[0].display_name };
  } catch (e) {
    return null;
  }
}
function distKm(a, b) {
  const R = 6371, toR = (d) => d * Math.PI / 180;
  const dLat = toR(b.lat - a.lat), dLng = toR(b.lng - a.lng);
  const x = Math.sin(dLat / 2) ** 2 + Math.cos(toR(a.lat)) * Math.cos(toR(b.lat)) * Math.sin(dLng / 2) ** 2;
  return 2 * R * Math.asin(Math.min(1, Math.sqrt(x)));
}
function findNeighbours(tile, allTiles, maxKm = 1.6) {
  if (!tile) return [];
  return allTiles.filter((t) => t.tileId !== tile.tileId && distKm(tile, t) <= maxKm).slice(0, 8);
}
function readUrlState() {
  if (typeof window === "undefined") return {};
  const p = new URLSearchParams(window.location.search);
  return {
    tile: p.get("tile") || "",
    gift: p.get("gift") === "1",
    order: p.get("order") || ""
  };
}
function writeUrlState({ tile, gift }) {
  var _a;
  if (typeof window === "undefined" || !((_a = window.history) == null ? void 0 : _a.replaceState)) return;
  const p = new URLSearchParams(window.location.search);
  if (tile) p.set("tile", tile);
  else p.delete("tile");
  if (gift) p.set("gift", "1");
  else p.delete("gift");
  const qs = p.toString();
  const next = window.location.pathname + (qs ? "?" + qs : "") + window.location.hash;
  window.history.replaceState(null, "", next);
}
function BaseColorSelector({ value, onChange, ink, bone, stone, line }) {
  const btn = function(color, label, swatchHex) {
    const selected = value === color;
    return /* @__PURE__ */ React.createElement(
      "button",
      {
        type: "button",
        onClick: function() {
          if (!selected) onChange(color);
        },
        "aria-pressed": selected,
        style: {
          display: "inline-flex",
          alignItems: "center",
          gap: 8,
          padding: "9px 14px",
          background: selected ? ink : "transparent",
          color: selected ? bone : ink,
          border: "1px solid " + ink,
          fontFamily: "Inter, sans-serif",
          fontSize: 12,
          fontWeight: 500,
          cursor: "pointer",
          transition: "background 120ms, color 120ms"
        }
      },
      /* @__PURE__ */ React.createElement("span", { style: {
        width: 14,
        height: 14,
        borderRadius: 2,
        background: swatchHex,
        border: "1px solid " + (swatchHex === "#F0EFEA" ? "rgba(0,0,0,0.2)" : "transparent"),
        display: "inline-block",
        flexShrink: 0
      } }),
      label
    );
  };
  return /* @__PURE__ */ React.createElement("div", { style: {
    padding: "18px",
    background: "transparent",
    border: "1px solid " + line
  } }, /* @__PURE__ */ React.createElement("div", { style: {
    fontFamily: "Inter, sans-serif",
    fontSize: 10,
    fontWeight: 600,
    letterSpacing: "0.28em",
    textTransform: "uppercase",
    color: ink,
    marginBottom: 10
  } }, "Base colour"), /* @__PURE__ */ React.createElement("div", { style: { display: "flex", gap: 8, flexWrap: "wrap" } }, btn("black", "Black", "#1A1F26"), btn("white", "White", "#F0EFEA")), /* @__PURE__ */ React.createElement("div", { style: { fontSize: 11, color: stone, marginTop: 8, lineHeight: 1.5 } }, "Both colours ship free. The 3D preview updates instantly when you change."));
}
function CfTilePicker({ osDatahubKey, fallbackImage, variantId, price, manifestUrl, coverageUrl }) {
  const mapRef = React.useRef(null);
  const mapInstanceRef = React.useRef(null);
  const clusterRef = React.useRef(null);
  const overlayLayersRef = React.useRef({ neighbours: null, printBoundary: null });
  const [leafletReady, setLeafletReady] = React.useState(false);
  const initialUrl = React.useMemo(() => readUrlState(), []);
  const [selectedTile, setSelectedTile] = React.useState(null);
  const [pinnedTile, setPinnedTile] = React.useState(null);
  const [reverseLabel, setReverseLabel] = React.useState(null);
  const [query, setQuery] = React.useState("");
  const [searchTab, setSearchTab] = React.useState("city");
  const [searchOpen, setSearchOpen] = React.useState(false);
  const [searchBusy, setSearchBusy] = React.useState(false);
  const [searchHint, setSearchHint] = React.useState("");
  const [showPrintBoundary, setShowPrintBoundary] = React.useState(true);
  const [activeFilters, setActiveFilters] = React.useState({ ready: true, comingSoon: true });
  const [giftMode, setGiftMode] = React.useState(initialUrl.gift);
  const [giftMessage, setGiftMessage] = React.useState("");
  const [reorderId, setReorderId] = React.useState(initialUrl.order || "");
  const [copyState, setCopyState] = React.useState("");
  const [openFaqIdx, setOpenFaqIdx] = React.useState(-1);
  const [demoIdx, setDemoIdx] = React.useState(0);
  const [liveLabel, setLiveLabel] = React.useState(null);
  const [cartBusy, setCartBusy] = React.useState(false);
  const [cartError, setCartError] = React.useState(null);
  const [baseColor, setBaseColor] = React.useState("black");
  React.useEffect(function() {
    try {
      window.dispatchEvent(new CustomEvent("cf:base-color-change", {
        detail: { color: baseColor }
      }));
    } catch (_e) {
    }
  }, [baseColor]);
  React.useEffect(() => {
    function onLabelChange(e) {
      if (!e || !e.detail) return;
      setLiveLabel({
        title: e.detail.title || "",
        subline: e.detail.subline || "",
        coord: e.detail.coord || "",
        showCoords: e.detail.showCoords !== false
      });
    }
    window.addEventListener("cf:label-change", onLabelChange);
    return () => window.removeEventListener("cf:label-change", onLabelChange);
  }, []);
  React.useEffect(() => {
    let cancelled = false;
    function ready() {
      return typeof window !== "undefined" && window.leaflet && window.L && typeof window.L.markerClusterGroup === "function";
    }
    if (ready()) {
      setLeafletReady(true);
      return;
    }
    const id = setInterval(() => {
      if (ready()) {
        if (!cancelled) setLeafletReady(true);
        clearInterval(id);
      }
    }, 100);
    const giveUp = setTimeout(() => {
      clearInterval(id);
    }, 8e3);
    return () => {
      cancelled = true;
      clearInterval(id);
      clearTimeout(giveUp);
    };
  }, []);
  const [manifest, setManifest] = React.useState(null);
  React.useEffect(() => {
    if (!manifestUrl) return;
    let cancelled = false;
    fetch(proxied(manifestUrl), { cache: "default" }).then((r) => r.ok ? r.json() : Promise.reject(`HTTP ${r.status}`)).then((data) => {
      if (!cancelled) setManifest(data);
    }).catch((err) => console.warn("[picker] manifest fetch failed:", err));
    return () => {
      cancelled = true;
    };
  }, [manifestUrl]);
  const allTiles = React.useMemo(() => {
    const byId = /* @__PURE__ */ new Map();
    if (manifest && manifest.tiles) {
      for (const [tileId, t] of Object.entries(manifest.tiles)) {
        if (typeof t.lat !== "number" || typeof t.lng !== "number") continue;
        byId.set(tileId, {
          tileId,
          handle: null,
          lat: t.lat,
          lng: t.lng,
          place: t.place || "",
          locality: ""
        });
      }
    }
    for (const t of CATALOGUE_TILES) byId.set(t.tileId, t);
    return Array.from(byId.values());
  }, [manifest]);
  const tileById = React.useMemo(() => {
    const m = /* @__PURE__ */ new Map();
    for (const t of allTiles) m.set(t.tileId, t);
    return m;
  }, [allTiles]);
  const suggestions = React.useMemo(() => {
    const q = query.trim().toLowerCase();
    if (searchTab !== "city" || !q) return [];
    const hits = [];
    for (const t of allTiles) {
      const hay = (t.place + " " + (t.locality || "") + " " + t.tileId).toLowerCase();
      const idx = hay.indexOf(q);
      if (idx >= 0) hits.push({ tile: t, score: idx });
      if (hits.length > 60) break;
    }
    hits.sort((a, b) => a.score - b.score || a.tile.place.localeCompare(b.tile.place));
    return hits.slice(0, 10).map((h) => h.tile);
  }, [query, searchTab, allTiles]);
  const visibleTiles = React.useMemo(() => {
    return allTiles.filter((t) => {
      const ready = !!resolveTileAssets(t, manifest);
      return ready && activeFilters.ready || !ready && activeFilters.comingSoon;
    });
  }, [allTiles, manifest, activeFilters]);
  React.useEffect(() => {
    if (!leafletReady || !mapRef.current || mapInstanceRef.current) return;
    const L = window.L;
    const map = L.map(mapRef.current, {
      center: [54.5, -2.5],
      zoom: 6,
      zoomControl: true,
      scrollWheelZoom: true
    });
    let tileUrl, tileAttr;
    if (osDatahubKey) {
      tileUrl = `https://api.os.uk/maps/raster/v1/zxy/Light_3857/{z}/{x}/{y}.png?key=${osDatahubKey}`;
      tileAttr = "Contains OS data \xA9 Crown copyright and database right " + (/* @__PURE__ */ new Date()).getFullYear();
    } else {
      tileUrl = "https://{s}.tile.openstreetmap.org/{z}/{x}/{y}.png";
      tileAttr = '\xA9 <a href="https://www.openstreetmap.org/copyright">OpenStreetMap</a> contributors';
    }
    L.tileLayer(tileUrl, { attribution: tileAttr, maxZoom: 18, minZoom: 5 }).addTo(map);
    mapInstanceRef.current = map;
    return () => {
      map.remove();
      mapInstanceRef.current = null;
    };
  }, [leafletReady, osDatahubKey]);
  React.useEffect(() => {
    if (!leafletReady || !coverageUrl) return;
    const map = mapInstanceRef.current;
    if (!map) return;
    const L = window.L;
    let layer = null, cancelled = false;
    fetch(coverageUrl, { cache: "default" }).then((r) => r.ok ? r.json() : Promise.reject(`HTTP ${r.status}`)).then((g) => {
      if (cancelled) return;
      layer = L.geoJSON(g, {
        style: (feature) => {
          const s = feature.properties.status;
          if (s === "live") return { color: "#3A7D44", weight: 1.2, fillColor: "#3A7D44", fillOpacity: 0.18, interactive: false };
          if (s === "coming") return { color: "#C28B30", weight: 1, fillColor: "#E8C36E", fillOpacity: 0.14, dashArray: "4,4", interactive: false };
          return { color: "#9A9F95", weight: 0.8, fillColor: "#C8CDC4", fillOpacity: 0.2, interactive: false };
        }
      });
      layer.addTo(map);
    }).catch((err) => console.warn("[picker] coverage overlay fetch failed:", err));
    return () => {
      cancelled = true;
      if (layer) map.removeLayer(layer);
    };
  }, [leafletReady, coverageUrl]);
  React.useEffect(() => {
    if (!leafletReady) return;
    const map = mapInstanceRef.current;
    if (!map) return;
    const L = window.L;
    if (clusterRef.current) {
      map.removeLayer(clusterRef.current);
      clusterRef.current = null;
    }
    const cluster = L.markerClusterGroup({
      maxClusterRadius: 60,
      showCoverageOnHover: false,
      spiderfyOnMaxZoom: true,
      chunkedLoading: true,
      iconCreateFunction: (c) => {
        const n = c.getChildCount();
        const size = n < 10 ? 32 : n < 100 ? 40 : n < 500 ? 48 : 56;
        return L.divIcon({
          html: `<div style="width:${size}px;height:${size}px;border-radius:50%;background:rgba(26,31,38,0.92);color:#F7F8F6;display:flex;align-items:center;justify-content:center;font:600 ${Math.max(11, size / 3)}px/1 Inter,sans-serif;letter-spacing:0.02em;box-shadow:0 2px 8px rgba(0,0,0,0.25);border:2px solid #F7F8F6;">${n}</div>`,
          className: "cf-cluster-icon",
          iconSize: L.point(size, size)
        });
      }
    });
    visibleTiles.forEach((tile) => {
      const isSelected = selectedTile && selectedTile.tileId === tile.tileId;
      const isPinned = pinnedTile && pinnedTile.tileId === tile.tileId;
      const hasAssets = !!resolveTileAssets(tile, manifest);
      const ringColour = isSelected ? "#1A1F26" : isPinned ? "#3A7D44" : hasAssets ? "#D34833" : "#C8CDC4";
      const marker = L.circleMarker([tile.lat, tile.lng], {
        radius: isSelected ? 10 : 7,
        color: "#1A1F26",
        weight: 1.5,
        fillColor: ringColour,
        fillOpacity: 1,
        interactive: true
      });
      marker.bindTooltip(
        `<b>${tile.place}</b>${tile.locality ? " \xB7 " + tile.locality : ""}<br/>${hasAssets ? "Ships in 7 days" : "Custom request"}`,
        { direction: "top", sticky: false, offset: [0, -10] }
      );
      marker.on("click", () => onSelectTile(tile, { fly: false }));
      cluster.addLayer(marker);
    });
    cluster.addTo(map);
    clusterRef.current = cluster;
  }, [leafletReady, visibleTiles, selectedTile, pinnedTile, manifest]);
  React.useEffect(() => {
    if (!leafletReady) return;
    const map = mapInstanceRef.current;
    if (!map) return;
    const L = window.L;
    const layers = overlayLayersRef.current;
    if (layers.printBoundary) {
      map.removeLayer(layers.printBoundary);
      layers.printBoundary = null;
    }
    if (layers.neighbours) {
      map.removeLayer(layers.neighbours);
      layers.neighbours = null;
    }
    if (!selectedTile) return;
    const mPerLat = 111320;
    const mPerLng = 111320 * Math.cos(selectedTile.lat * Math.PI / 180);
    const dLat = 500 / mPerLat, dLng = 500 / mPerLng;
    const bounds = [
      [selectedTile.lat - dLat, selectedTile.lng - dLng],
      [selectedTile.lat + dLat, selectedTile.lng + dLng]
    ];
    if (showPrintBoundary) {
      layers.printBoundary = L.rectangle(bounds, {
        color: "#1A1F26",
        weight: 2,
        dashArray: "6,4",
        fillColor: "#1A1F26",
        fillOpacity: 0.06,
        interactive: false
      }).addTo(map);
    }
    const ghosts = findNeighbours(selectedTile, allTiles);
    if (ghosts.length) {
      const group = L.layerGroup();
      ghosts.forEach((g) => {
        L.circleMarker([g.lat, g.lng], {
          radius: 9,
          color: "#3A7D44",
          weight: 1.5,
          fillColor: "#A8C8AB",
          fillOpacity: 0.45,
          dashArray: "3,3"
        }).bindTooltip(
          `Or pick next door: <b>${g.place}</b>${g.locality ? " \xB7 " + g.locality : ""}`,
          { direction: "top", sticky: false, offset: [0, -10] }
        ).on("click", () => onSelectTile(g)).addTo(group);
      });
      group.addTo(map);
      layers.neighbours = group;
    }
  }, [leafletReady, selectedTile, showPrintBoundary, allTiles]);
  React.useEffect(() => {
    writeUrlState({ tile: (selectedTile == null ? void 0 : selectedTile.tileId) || "", gift: giftMode });
    if (!selectedTile) {
      setReverseLabel(null);
      return;
    }
    let cancelled = false;
    setReverseLabel("Identifying\u2026");
    reverseGeocode(selectedTile.lat, selectedTile.lng).then((label) => {
      if (!cancelled) setReverseLabel(label || null);
    });
    return () => {
      cancelled = true;
    };
  }, [selectedTile, giftMode]);
  const restoredRef = React.useRef(false);
  React.useEffect(() => {
    if (restoredRef.current || !allTiles.length) return;
    const want = initialUrl.tile;
    if (!want) {
      restoredRef.current = true;
      return;
    }
    const hit = tileById.get(want);
    if (hit) {
      onSelectTile(hit);
      restoredRef.current = true;
    }
  }, [allTiles, tileById]);
  React.useEffect(() => {
    if (selectedTile) return;
    const id = setInterval(() => setDemoIdx((i) => (i + 1) % EXAMPLE_CARDS.length), 6500);
    return () => clearInterval(id);
  }, [selectedTile]);
  function onSelectTile(tile, opts = {}) {
    if (!tile) return;
    const fly = opts.fly !== false;
    setSelectedTile(tile);
    setSearchOpen(false);
    const map = mapInstanceRef.current;
    if (map && fly) {
      const targetZoom = Math.max(map.getZoom(), 13);
      map.setView([tile.lat, tile.lng], targetZoom, { animate: true });
    }
    setTimeout(() => {
      const el = document.getElementById("cf-picker-preview");
      if (el && fly) el.scrollIntoView({ behavior: "smooth", block: "start" });
    }, 600);
  }
  function togglePin() {
    if (!selectedTile) return;
    if (pinnedTile && pinnedTile.tileId === selectedTile.tileId) setPinnedTile(null);
    else setPinnedTile(selectedTile);
  }
  async function copyShareUrl() {
    if (!navigator.clipboard) {
      setCopyState("failed");
      return;
    }
    try {
      await navigator.clipboard.writeText(window.location.href);
      setCopyState("copied");
      setTimeout(() => setCopyState(""), 2200);
    } catch (e) {
      setCopyState("failed");
      setTimeout(() => setCopyState(""), 2200);
    }
  }
  async function handlePostcodeSubmit() {
    const q = query.trim();
    if (!q) return;
    setSearchBusy(true);
    setSearchHint("");
    const hit = await geocodePostcode(q);
    setSearchBusy(false);
    if (!hit) {
      setSearchHint("Couldn't find that postcode \u2014 try a city instead.");
      return;
    }
    let best = null, bestKm = Infinity;
    for (const t of allTiles) {
      const d = distKm(hit, t);
      if (d < bestKm) {
        bestKm = d;
        best = t;
      }
    }
    if (!best) {
      setSearchHint("No covered tiles nearby.");
      return;
    }
    if (bestKm > 4) {
      setSearchHint(`Nearest baked tile is ${bestKm.toFixed(1)} km away (${best.place}). Email studio@cityform.co.uk to bake your exact area.`);
    } else {
      setSearchHint(`Found: ${best.place}${best.locality ? " \xB7 " + best.locality : ""} (${bestKm.toFixed(1)} km away).`);
    }
    onSelectTile(best);
  }
  function handleReorderSubmit() {
    const id = reorderId.trim().toUpperCase();
    if (!id) return;
    window.location.href = `/cart?order_ref=${encodeURIComponent(id)}`;
  }
  const selectedAssets = selectedTile ? resolveTileAssets(selectedTile, manifest) : null;
  const labelDefaults = selectedAssets ? {
    title: selectedAssets.title,
    subline: selectedAssets.subline,
    coords: selectedAssets.coord,
    showCoords: true
  } : null;
  const pinnedAssets = pinnedTile ? resolveTileAssets(pinnedTile, manifest) : null;
  async function handleAddToCart() {
    if (!selectedTile || !selectedAssets || !variantId) return;
    setCartBusy(true);
    setCartError(null);
    const eng = liveLabel || {
      title: labelDefaults.title,
      subline: labelDefaults.subline,
      coord: labelDefaults.coords,
      showCoords: labelDefaults.showCoords
    };
    const properties = {
      "Tile ID": selectedTile.tileId,
      "Place": selectedTile.place + (selectedTile.locality ? " \xB7 " + selectedTile.locality : ""),
      "Centre (lat,lng)": `${selectedTile.lat.toFixed(4)},${selectedTile.lng.toFixed(4)}`,
      "Engraving": eng.title || "",
      "Personalised": "yes"
    };
    if (eng.subline) properties["Locality"] = eng.subline;
    if (eng.showCoords && eng.coord) properties["Coordinates"] = eng.coord;
    if (selectedAssets.glb) properties["_Source GLB"] = selectedAssets.glb;
    if (baseColor === "white") properties["Base color"] = "White";
    if (giftMode) {
      properties["Gift wrap"] = "yes";
      if (giftMessage.trim()) properties["Gift message"] = giftMessage.trim().slice(0, 60);
    }
    try {
      const formData = new FormData();
      formData.append("id", String(variantId));
      formData.append("quantity", "1");
      for (const [k, v] of Object.entries(properties)) formData.append(`properties[${k}]`, v);
      const resp = await fetch("/cart/add.js", { method: "POST", body: formData });
      if (!resp.ok) throw new Error(`cart/add.js returned ${resp.status}`);
      window.location.href = "/cart";
    } catch (err) {
      setCartError(err.message || "Could not add to cart. Please try again.");
      setCartBusy(false);
    }
  }
  const readyCount = allTiles.reduce((n, t) => n + (resolveTileAssets(t, manifest) ? 1 : 0), 0);
  const ink = "var(--ink, #1A1F26)";
  const bone = "var(--bone, #F7F8F6)";
  const stone = "var(--stone, #6E7479)";
  const line = "var(--line, #C8CDC4)";
  const mist = "var(--mist, #EEEFEB)";
  const surface2 = "var(--surface-2, #ECEFEB)";
  return /* @__PURE__ */ React.createElement("div", { style: { background: bone, minHeight: "60vh" } }, /* @__PURE__ */ React.createElement(SpecStrip, { price }), /* @__PURE__ */ React.createElement("div", { style: { padding: "40px 24px 16px", maxWidth: 1280, margin: "0 auto" } }, /* @__PURE__ */ React.createElement("div", { style: { display: "flex", alignItems: "center", flexWrap: "wrap", gap: 16, marginBottom: 14 } }, /* @__PURE__ */ React.createElement("span", { style: { fontSize: 10, letterSpacing: "0.32em", textTransform: "uppercase", color: stone } }, "Make Yours \xB7 9 \xD7 9 cm \xB7 1:11,000"), /* @__PURE__ */ React.createElement("button", { onClick: () => setGiftMode((g) => !g), style: {
    padding: "6px 12px",
    borderRadius: 100,
    cursor: "pointer",
    border: "1px solid " + (giftMode ? ink : line),
    background: giftMode ? ink : "transparent",
    color: giftMode ? bone : ink,
    fontFamily: "Inter, sans-serif",
    fontSize: 11,
    fontWeight: 600,
    letterSpacing: "0.16em",
    textTransform: "uppercase"
  } }, giftMode ? "\u{1F381} Gift mode on" : "\u{1F381} Gift mode")), /* @__PURE__ */ React.createElement("h1", { style: {
    fontFamily: "Inter, sans-serif",
    fontWeight: 600,
    fontSize: "clamp(36px, 5vw, 60px)",
    letterSpacing: "-0.025em",
    lineHeight: 1,
    margin: 0,
    color: ink,
    maxWidth: 760
  } }, giftMode ? "Pick the kilometre that means something." : "Make your street."), /* @__PURE__ */ React.createElement("p", { style: {
    fontFamily: "Inter, sans-serif",
    fontSize: 16,
    lineHeight: 1.55,
    color: stone,
    maxWidth: 680,
    marginTop: 14,
    marginBottom: 0
  } }, giftMode ? "A 9 \xD7 9 cm 3D-printed model of a 1 km square in England, Wales or most of Scotland \u2014 first home, wedding venue, family birthplace. Engraved with the city + coordinates, gift-wrapped, with a hand-written note." : "A 9 \xD7 9 cm 3D-printed model of a 1 km square in England, Wales or most of Scotland, made to order. Engraved with the city + coordinates, finished by hand, posted within a week.")), /* @__PURE__ */ React.createElement("div", { style: { padding: "8px 24px 24px", maxWidth: 1280, margin: "0 auto" } }, /* @__PURE__ */ React.createElement("div", { style: { fontSize: 10, letterSpacing: "0.32em", textTransform: "uppercase", color: stone, marginBottom: 10 } }, "Try one of these"), /* @__PURE__ */ React.createElement("div", { style: {
    display: "grid",
    gridTemplateColumns: "repeat(auto-fit, minmax(220px, 1fr))",
    gap: 12
  } }, EXAMPLE_CARDS.map((ex) => {
    const tile = tileById.get(ex.tileId);
    if (!tile) return null;
    return /* @__PURE__ */ React.createElement(
      "button",
      {
        key: ex.tileId,
        onClick: () => onSelectTile(tile),
        style: {
          textAlign: "left",
          padding: "16px 18px",
          border: "1px solid " + line,
          background: bone,
          cursor: "pointer",
          display: "block",
          transition: "transform 0.15s ease, border-color 0.15s ease"
        },
        onMouseEnter: (e) => {
          e.currentTarget.style.borderColor = ink;
          e.currentTarget.style.transform = "translateY(-2px)";
        },
        onMouseLeave: (e) => {
          e.currentTarget.style.borderColor = line;
          e.currentTarget.style.transform = "";
        }
      },
      /* @__PURE__ */ React.createElement("div", { style: { fontFamily: "Inter, sans-serif", fontSize: 15, fontWeight: 600, color: ink, letterSpacing: "-0.005em" } }, ex.place, ex.locality ? " \xB7 " + ex.locality : ""),
      /* @__PURE__ */ React.createElement("div", { style: { marginTop: 6, fontSize: 12, lineHeight: 1.5, color: stone } }, ex.line),
      /* @__PURE__ */ React.createElement("div", { style: { marginTop: 10, fontSize: 10, letterSpacing: "0.18em", textTransform: "uppercase", color: ink } }, "Try it \u2192")
    );
  }))), /* @__PURE__ */ React.createElement("div", { style: { padding: "0 24px 32px", maxWidth: 1280, margin: "0 auto" } }, /* @__PURE__ */ React.createElement(
    SearchTabs,
    {
      searchTab,
      setSearchTab: (t) => {
        setSearchTab(t);
        setSearchHint("");
        setQuery("");
        setSearchOpen(false);
      },
      query,
      setQuery: (v) => {
        setQuery(v);
        setSearchOpen(true);
      },
      suggestions,
      onPick: (t) => {
        setQuery("");
        onSelectTile(t);
      },
      onPostcodeSubmit: handlePostcodeSubmit,
      searchBusy,
      searchHint,
      searchOpen,
      setSearchOpen,
      ink,
      bone,
      stone,
      line,
      mist
    }
  ), searchTab === "city" && !query ? /* @__PURE__ */ React.createElement("div", { style: { display: "flex", flexWrap: "wrap", gap: 8, marginTop: 12 } }, /* @__PURE__ */ React.createElement("span", { style: { fontSize: 10, letterSpacing: "0.32em", textTransform: "uppercase", color: stone, marginRight: 6, alignSelf: "center" } }, "Popular"), POPULAR_PICKS.map((p) => {
    const t = tileById.get(p.tileId);
    if (!t) return null;
    return /* @__PURE__ */ React.createElement("button", { key: p.tileId, onClick: () => onSelectTile(t), style: {
      padding: "6px 12px",
      borderRadius: 100,
      cursor: "pointer",
      border: "1px solid " + line,
      background: bone,
      color: ink,
      fontFamily: "Inter, sans-serif",
      fontSize: 12,
      fontWeight: 500
    } }, p.place);
  })) : null, /* @__PURE__ */ React.createElement("div", { style: { marginTop: 14, display: "flex", alignItems: "center", gap: 10, flexWrap: "wrap" } }, /* @__PURE__ */ React.createElement("span", { style: { fontSize: 10, letterSpacing: "0.32em", textTransform: "uppercase", color: stone } }, "Re-ordering?"), /* @__PURE__ */ React.createElement(
    "input",
    {
      type: "text",
      value: reorderId,
      onChange: (e) => setReorderId(e.target.value),
      onKeyDown: (e) => {
        if (e.key === "Enter") handleReorderSubmit();
      },
      placeholder: "CF-\u2026  (paste your order ID)",
      style: {
        flex: "0 1 260px",
        padding: "8px 12px",
        border: "1px solid " + line,
        background: "transparent",
        fontFamily: "Inter, sans-serif",
        fontSize: 12,
        color: ink
      }
    }
  ), reorderId.trim() ? /* @__PURE__ */ React.createElement("button", { onClick: handleReorderSubmit, style: {
    padding: "8px 14px",
    cursor: "pointer",
    border: "1px solid " + ink,
    background: "transparent",
    fontFamily: "Inter, sans-serif",
    fontSize: 11,
    fontWeight: 600,
    letterSpacing: "0.18em",
    textTransform: "uppercase",
    color: ink
  } }, "Load") : null), /* @__PURE__ */ React.createElement("div", { style: { marginTop: 20, marginBottom: 10, display: "flex", flexWrap: "wrap", gap: 8, alignItems: "center" } }, /* @__PURE__ */ React.createElement(
    FilterChip,
    {
      label: "Ships 7 days",
      dot: "#D34833",
      active: activeFilters.ready,
      onClick: () => setActiveFilters((f) => ({ ...f, ready: !f.ready })),
      ink,
      bone,
      line
    }
  ), /* @__PURE__ */ React.createElement(
    FilterChip,
    {
      label: "Ships 14 days (Wales & Scotland)",
      dot: "#E8C36E",
      active: activeFilters.comingSoon,
      onClick: () => setActiveFilters((f) => ({ ...f, comingSoon: !f.comingSoon })),
      ink,
      bone,
      line
    }
  ), /* @__PURE__ */ React.createElement("span", { style: { marginLeft: "auto", fontSize: 11, letterSpacing: "0.18em", textTransform: "uppercase", color: stone } }, readyCount.toLocaleString(), " areas ready \xB7 England, Wales & most of Scotland")), /* @__PURE__ */ React.createElement("div", { ref: mapRef, className: "cf-picker-map", style: {
    height: "min(60vh, 560px)",
    border: "1px solid " + ink,
    background: surface2
  } }), /* @__PURE__ */ React.createElement("div", { style: { marginTop: 10, fontSize: 11, color: stone, display: "flex", justifyContent: "space-between", alignItems: "center", flexWrap: "wrap", gap: 8 } }, /* @__PURE__ */ React.createElement("span", null, "Welsh and Scottish prints ship in ~14 working days. Email ", /* @__PURE__ */ React.createElement("a", { href: "mailto:studio@cityform.co.uk?subject=Make%20Yours%20%E2%80%94%20area%20request", style: { color: ink, textDecoration: "underline" } }, "studio@cityform.co.uk"), " if your area isn't on the map yet \u2014 we cover England, Wales, and most of mainland Scotland (we usually reply within 48 hours)."), selectedTile ? /* @__PURE__ */ React.createElement("button", { onClick: () => setShowPrintBoundary((p) => !p), style: {
    padding: "6px 12px",
    cursor: "pointer",
    border: "1px solid " + line,
    background: bone,
    color: ink,
    fontFamily: "Inter, sans-serif",
    fontSize: 10,
    fontWeight: 600,
    letterSpacing: "0.18em",
    textTransform: "uppercase"
  } }, showPrintBoundary ? "Hide print boundary" : "Show print boundary") : null)), /* @__PURE__ */ React.createElement("div", { id: "cf-picker-preview", style: { padding: "32px 24px", maxWidth: 1280, margin: "0 auto" } }, !selectedTile ? /* @__PURE__ */ React.createElement(EmptyPreview, { demoIdx, demoCards: EXAMPLE_CARDS, tileById, onSelectTile, ink, bone, stone, line, fallbackImage }) : !selectedAssets ? /* @__PURE__ */ React.createElement(ComingSoonNotice, { selectedTile, ink, stone, line, surface2 }) : /* @__PURE__ */ React.createElement(
    SelectedTilePane,
    {
      selectedTile,
      selectedAssets,
      pinnedTile,
      pinnedAssets,
      reverseLabel,
      labelDefaults,
      fallbackImage,
      giftMode,
      giftMessage,
      setGiftMessage,
      onTogglePin: togglePin,
      onCopyShare: copyShareUrl,
      copyState,
      cartBusy,
      cartError,
      variantId,
      price,
      handleAddToCart,
      baseColor,
      setBaseColor,
      ink,
      bone,
      stone,
      line,
      mist
    }
  )), /* @__PURE__ */ React.createElement(RecentOrders, { allTiles, tileById, onSelectTile, ink, bone, stone, line }), /* @__PURE__ */ React.createElement(FaqBlock, { openIdx: openFaqIdx, setOpenIdx: setOpenFaqIdx, ink, stone, line }), selectedTile && selectedAssets ? /* @__PURE__ */ React.createElement(MobileStickyCta, { price, cartBusy, handleAddToCart, ink, bone }) : null);
}
function SpecStrip({ price }) {
  return /* @__PURE__ */ React.createElement("div", { style: {
    background: "var(--ink, #1A1F26)",
    color: "var(--bone, #F7F8F6)",
    padding: "10px 24px",
    display: "flex",
    flexWrap: "wrap",
    justifyContent: "center",
    gap: "6px 22px",
    fontFamily: "Inter, sans-serif",
    fontSize: 11,
    fontWeight: 500,
    letterSpacing: "0.18em",
    textTransform: "uppercase"
  } }, /* @__PURE__ */ React.createElement("span", { style: { fontWeight: 700 } }, price || "\xA345"), /* @__PURE__ */ React.createElement("span", null, "9 \xD7 9 cm"), /* @__PURE__ */ React.createElement("span", null, "1 km \xD7 1 km"), /* @__PURE__ */ React.createElement("span", null, "matte PLA \xB7 black or white base"), /* @__PURE__ */ React.createElement("span", null, "free standard engraving"), /* @__PURE__ */ React.createElement("span", null, "personalise +\xA33"), /* @__PURE__ */ React.createElement("span", null, "ships in 7 days"), /* @__PURE__ */ React.createElement("span", null, "free UK shipping"));
}
function SearchTabs({ searchTab, setSearchTab, query, setQuery, suggestions, onPick, onPostcodeSubmit, searchBusy, searchHint, searchOpen, setSearchOpen, ink, bone, stone, line, mist }) {
  const placeholder = searchTab === "city" ? "Start typing \u2014 e.g. Sheffield, Pitlochry, my street\u2026" : searchTab === "postcode" ? "Enter a UK postcode \u2014 e.g. S1 2HE, EH1 1YZ" : "three.word.address \u2014 e.g. ///filled.count.soap";
  function onKeyDown(e) {
    if (e.key === "Enter") {
      if (searchTab === "postcode") onPostcodeSubmit();
      else if (suggestions.length) {
        onPick(suggestions[0]);
      }
    } else if (e.key === "Escape") {
      setSearchOpen(false);
    }
  }
  function onW3WSubmit() {
    const q = query.trim();
    if (!q) return;
    window.location.href = `mailto:studio@cityform.co.uk?subject=${encodeURIComponent("what3words request \u2014 " + q)}&body=${encodeURIComponent("Could you bake the 1 km square around " + q + "?\n\nThanks.")}`;
  }
  return /* @__PURE__ */ React.createElement("div", { style: { position: "relative" } }, /* @__PURE__ */ React.createElement("div", { style: { display: "flex", gap: 0, borderBottom: "1px solid " + line, marginBottom: 12 } }, [["city", "City"], ["postcode", "Postcode"], ["w3w", "what3words"]].map(([k, lbl]) => {
    const active = searchTab === k;
    return /* @__PURE__ */ React.createElement("button", { key: k, onClick: () => setSearchTab(k), style: {
      padding: "10px 18px",
      cursor: "pointer",
      border: "none",
      background: "transparent",
      borderBottom: active ? "2px solid " + ink : "2px solid transparent",
      color: active ? ink : stone,
      marginBottom: -1,
      fontFamily: "Inter, sans-serif",
      fontSize: 11,
      fontWeight: 600,
      letterSpacing: "0.22em",
      textTransform: "uppercase"
    } }, lbl);
  })), /* @__PURE__ */ React.createElement("div", { style: { position: "relative" } }, /* @__PURE__ */ React.createElement(
    "input",
    {
      type: "search",
      value: query,
      onChange: (e) => {
        setQuery(e.target.value);
        setSearchOpen(true);
      },
      onFocus: () => setSearchOpen(true),
      onKeyDown,
      placeholder,
      style: {
        width: "100%",
        padding: "14px 16px",
        border: "1px solid " + ink,
        background: bone,
        color: ink,
        fontFamily: "Inter, sans-serif",
        fontSize: 14,
        boxSizing: "border-box"
      }
    }
  ), searchTab === "postcode" ? /* @__PURE__ */ React.createElement(
    "button",
    {
      onClick: onPostcodeSubmit,
      disabled: searchBusy,
      style: {
        position: "absolute",
        right: 6,
        top: 6,
        bottom: 6,
        padding: "0 16px",
        cursor: searchBusy ? "wait" : "pointer",
        border: "none",
        background: ink,
        color: bone,
        fontFamily: "Inter, sans-serif",
        fontSize: 11,
        fontWeight: 600,
        letterSpacing: "0.22em",
        textTransform: "uppercase"
      }
    },
    searchBusy ? "Finding\u2026" : "Find"
  ) : null, searchTab === "w3w" && query.trim() ? /* @__PURE__ */ React.createElement(
    "button",
    {
      onClick: onW3WSubmit,
      style: {
        position: "absolute",
        right: 6,
        top: 6,
        bottom: 6,
        padding: "0 16px",
        cursor: "pointer",
        border: "none",
        background: ink,
        color: bone,
        fontFamily: "Inter, sans-serif",
        fontSize: 11,
        fontWeight: 600,
        letterSpacing: "0.22em",
        textTransform: "uppercase"
      }
    },
    "Email us"
  ) : null, searchTab === "city" && searchOpen && suggestions.length ? /* @__PURE__ */ React.createElement("div", { style: {
    position: "absolute",
    top: "calc(100% + 4px)",
    left: 0,
    right: 0,
    background: bone,
    border: "1px solid " + ink,
    boxShadow: "0 8px 24px rgba(0,0,0,0.08)",
    zIndex: 30,
    maxHeight: 360,
    overflowY: "auto"
  } }, suggestions.map((t) => /* @__PURE__ */ React.createElement(
    "button",
    {
      key: t.tileId,
      onClick: () => onPick(t),
      style: {
        display: "block",
        width: "100%",
        textAlign: "left",
        padding: "12px 16px",
        cursor: "pointer",
        border: "none",
        background: "transparent",
        fontFamily: "Inter, sans-serif",
        fontSize: 13,
        color: ink,
        borderBottom: "1px solid " + mist
      },
      onMouseEnter: (e) => e.currentTarget.style.background = mist,
      onMouseLeave: (e) => e.currentTarget.style.background = "transparent"
    },
    /* @__PURE__ */ React.createElement("span", { style: { fontWeight: 600 } }, t.place),
    t.locality ? /* @__PURE__ */ React.createElement("span", { style: { color: stone } }, " \xB7 ", t.locality) : null,
    /* @__PURE__ */ React.createElement("span", { style: { marginLeft: 8, fontSize: 10, color: stone, letterSpacing: "0.16em" } }, t.tileId)
  ))) : null), searchHint ? /* @__PURE__ */ React.createElement("div", { style: { marginTop: 8, fontSize: 12, color: stone } }, searchHint) : null);
}
function FilterChip({ label, dot, active, onClick, ink, bone, line }) {
  return /* @__PURE__ */ React.createElement("button", { onClick, style: {
    padding: "8px 14px",
    borderRadius: 100,
    cursor: "pointer",
    border: "1px solid " + (active ? ink : line),
    background: active ? ink : "transparent",
    color: active ? bone : ink,
    fontFamily: "Inter, sans-serif",
    fontSize: 11,
    fontWeight: 600,
    letterSpacing: "0.16em",
    textTransform: "uppercase",
    display: "inline-flex",
    alignItems: "center",
    gap: 8
  } }, /* @__PURE__ */ React.createElement("span", { style: { width: 10, height: 10, borderRadius: "50%", background: dot, display: "inline-block" } }), label);
}
function EmptyPreview({ demoIdx, demoCards, tileById, onSelectTile, ink, bone, stone, line, fallbackImage }) {
  const card = demoCards[demoIdx];
  const tile = tileById.get(card.tileId);
  const assets = tile ? resolveTileAssets(tile, null) : null;
  return /* @__PURE__ */ React.createElement("div", { style: {
    display: "grid",
    gridTemplateColumns: "minmax(0, 1fr)",
    gap: 16,
    padding: "32px 24px",
    background: "var(--surface-2, #ECEFEB)",
    border: "1px solid " + line,
    textAlign: "center"
  } }, /* @__PURE__ */ React.createElement("div", { style: { fontSize: 10, letterSpacing: "0.32em", textTransform: "uppercase", color: stone } }, "See yours render in 48 hours"), /* @__PURE__ */ React.createElement("h2", { style: {
    fontFamily: "Inter, sans-serif",
    fontWeight: 600,
    fontSize: "clamp(20px, 2.4vw, 28px)",
    letterSpacing: "-0.012em",
    color: ink,
    margin: "0 auto",
    maxWidth: 540
  } }, "Click any kilometre to start \u2014 or try ", card.place, card.locality ? " \xB7 " + card.locality : "", " now."), /* @__PURE__ */ React.createElement("div", { style: { width: "100%", maxWidth: 520, margin: "0 auto", aspectRatio: "1 / 1", background: bone, border: "1px solid " + ink } }, window.Model3DViewer && assets ? /* @__PURE__ */ React.createElement(
    window.Model3DViewer,
    {
      url: assets.glb,
      fallback: fallbackImage,
      label: { title: assets.title, subline: assets.subline, coord: assets.coord, showCoords: true },
      height: "100%",
      autoRotate: true,
      autoRotateSpeed: -0.6
    }
  ) : null), /* @__PURE__ */ React.createElement("p", { style: { color: stone, fontSize: 13, maxWidth: 520, margin: "0 auto", lineHeight: 1.55 } }, card.line), /* @__PURE__ */ React.createElement("div", null, /* @__PURE__ */ React.createElement("button", { onClick: () => tile && onSelectTile(tile), style: {
    padding: "14px 28px",
    cursor: "pointer",
    border: "1px solid " + ink,
    background: ink,
    color: bone,
    fontFamily: "Inter, sans-serif",
    fontSize: 12,
    fontWeight: 600,
    letterSpacing: "0.22em",
    textTransform: "uppercase"
  } }, "Try ", card.place, " \u2192")));
}
function ComingSoonNotice({ selectedTile, ink, stone, line, surface2 }) {
  return /* @__PURE__ */ React.createElement("div", { style: {
    padding: "48px 32px",
    background: surface2,
    border: "1px solid " + line,
    textAlign: "center",
    color: ink
  } }, /* @__PURE__ */ React.createElement("strong", null, selectedTile.place, selectedTile.locality ? " \xB7 " + selectedTile.locality : ""), /* @__PURE__ */ React.createElement("div", { style: { marginTop: 12, fontSize: 13, color: stone } }, "We haven't baked this exact kilometre yet \u2014 email", " ", /* @__PURE__ */ React.createElement("a", { href: "mailto:studio@cityform.co.uk" }, "studio@cityform.co.uk"), " ", "with the area you'd like and we'll have a preview back in 48 hours."));
}
function SelectedTilePane({
  selectedTile,
  selectedAssets,
  pinnedTile,
  pinnedAssets,
  reverseLabel,
  labelDefaults,
  fallbackImage,
  giftMode,
  giftMessage,
  setGiftMessage,
  onTogglePin,
  onCopyShare,
  copyState,
  cartBusy,
  cartError,
  variantId,
  price,
  handleAddToCart,
  baseColor,
  setBaseColor,
  ink,
  bone,
  stone,
  line,
  mist
}) {
  const isPinned = pinnedTile && pinnedTile.tileId === selectedTile.tileId;
  return /* @__PURE__ */ React.createElement("div", { style: { display: "grid", gridTemplateColumns: "minmax(0, 1fr)", gap: 24 } }, /* @__PURE__ */ React.createElement("div", { style: { display: "flex", flexWrap: "wrap", alignItems: "baseline", gap: 12 } }, /* @__PURE__ */ React.createElement("h2", { style: { margin: 0, fontFamily: "Inter, sans-serif", fontWeight: 600, fontSize: "clamp(22px, 2.4vw, 30px)", letterSpacing: "-0.012em", color: ink } }, selectedTile.place, selectedTile.locality ? " \xB7 " + selectedTile.locality : ""), /* @__PURE__ */ React.createElement("span", { style: { fontSize: 11, color: stone, letterSpacing: "0.16em", textTransform: "uppercase" } }, selectedTile.tileId, " \xB7 ", selectedAssets.coord), /* @__PURE__ */ React.createElement("span", { style: { marginLeft: "auto", display: "flex", gap: 8 } }, /* @__PURE__ */ React.createElement("button", { onClick: onTogglePin, style: {
    padding: "8px 12px",
    cursor: "pointer",
    border: "1px solid " + (isPinned ? "#3A7D44" : line),
    background: isPinned ? "#3A7D44" : "transparent",
    color: isPinned ? bone : ink,
    fontFamily: "Inter, sans-serif",
    fontSize: 10,
    fontWeight: 600,
    letterSpacing: "0.18em",
    textTransform: "uppercase"
  } }, isPinned ? "\u{1F4CC} Pinned" : "Pin this view"), /* @__PURE__ */ React.createElement("button", { onClick: onCopyShare, style: {
    padding: "8px 12px",
    cursor: "pointer",
    border: "1px solid " + line,
    background: "transparent",
    color: ink,
    fontFamily: "Inter, sans-serif",
    fontSize: 10,
    fontWeight: 600,
    letterSpacing: "0.18em",
    textTransform: "uppercase"
  } }, copyState === "copied" ? "\u2713 Copied" : copyState === "failed" ? "Copy failed" : "Copy link"))), reverseLabel ? /* @__PURE__ */ React.createElement("div", { style: { fontSize: 12, color: stone, marginTop: -10 } }, "Centred on ", /* @__PURE__ */ React.createElement("strong", { style: { color: ink } }, reverseLabel)) : null, /* @__PURE__ */ React.createElement("div", { style: { fontSize: 12.5, color: stone, marginTop: reverseLabel ? 6 : 0, lineHeight: 1.55, maxWidth: 600 } }, "At ", /* @__PURE__ */ React.createElement("strong", { style: { color: ink } }, "1:11000"), " this whole kilometre becomes a 9 cm plate \u2014 you\u2019ll see the street pattern, water and landmarks, not individual houses.", " ", /* @__PURE__ */ React.createElement("a", { href: "/pages/how-its-made#scale", style: { color: ink, textDecoration: "underline", textDecorationColor: "#D34833", textUnderlineOffset: "2px" } }, "How it\u2019s made \u2192")), pinnedTile && pinnedAssets && pinnedTile.tileId !== selectedTile.tileId ? /* @__PURE__ */ React.createElement("div", { style: { display: "grid", gridTemplateColumns: "repeat(auto-fit, minmax(280px, 1fr))", gap: 16 } }, /* @__PURE__ */ React.createElement(PreviewCard, { tile: selectedTile, assets: selectedAssets, labelDefaults, fallbackImage, label: "Current pick", ink, bone, stone, line }), /* @__PURE__ */ React.createElement(PreviewCard, { tile: pinnedTile, assets: pinnedAssets, labelDefaults: null, fallbackImage, label: "Pinned", ink, bone, stone, line })) : /* @__PURE__ */ React.createElement("div", { style: { position: "relative", width: "100%", maxWidth: 720, margin: "0 auto", aspectRatio: "1 / 1", background: bone, border: "1px solid " + ink, overflow: "hidden" } }, window.Model3DViewer ? /* @__PURE__ */ React.createElement(
    window.Model3DViewer,
    {
      url: selectedAssets.glb,
      fallback: fallbackImage,
      label: labelDefaults ? { title: labelDefaults.title, subline: labelDefaults.subline, coord: labelDefaults.coords, showCoords: labelDefaults.showCoords !== false } : null,
      height: "100%",
      autoRotate: true,
      autoRotateSpeed: -0.6,
      showHint: true
    }
  ) : null), /* @__PURE__ */ React.createElement(
    BaseColorSelector,
    {
      value: baseColor,
      onChange: setBaseColor,
      ink,
      bone,
      stone,
      line
    }
  ), window.CfProductLabel ? /* @__PURE__ */ React.createElement(window.CfProductLabel, { handle: selectedTile.handle || "", defaults: labelDefaults, inline: true, suppressBaseSelector: true }) : null, giftMode ? /* @__PURE__ */ React.createElement("div", { style: { padding: 18, background: mist, border: "1px solid " + line } }, /* @__PURE__ */ React.createElement("div", { style: { fontSize: 10, letterSpacing: "0.32em", textTransform: "uppercase", color: stone, marginBottom: 10 } }, "\u{1F381} Gift mode"), /* @__PURE__ */ React.createElement("p", { style: { margin: "0 0 14px", color: ink, fontSize: 13, lineHeight: 1.55 } }, "Free gift-wrap. Add an optional hand-written message (we'll write it on a Cityform card and slip it in the box)."), /* @__PURE__ */ React.createElement("div", { style: { display: "flex", justifyContent: "space-between", alignItems: "baseline", marginBottom: 6 } }, /* @__PURE__ */ React.createElement("span", { style: { fontSize: 10, letterSpacing: "0.32em", textTransform: "uppercase", color: stone } }, "Message (optional)"), /* @__PURE__ */ React.createElement("span", { style: { fontSize: 10, color: stone, fontVariantNumeric: "tabular-nums" } }, giftMessage.length, "/60")), /* @__PURE__ */ React.createElement(
    "input",
    {
      type: "text",
      value: giftMessage,
      maxLength: 60,
      onChange: (e) => setGiftMessage(e.target.value),
      placeholder: "Happy anniversary \u2014 H \xD7 G",
      style: { width: "100%", padding: "10px 12px", border: "1px solid " + ink, background: bone, fontFamily: "Inter, sans-serif", fontSize: 14, boxSizing: "border-box" }
    }
  )) : null, selectedAssets.isBeta ? /* @__PURE__ */ React.createElement("div", { style: {
    padding: "14px 18px",
    background: "rgba(232, 171, 48, 0.12)",
    border: "1px solid var(--saffron, #E8AB30)",
    fontFamily: "Inter, sans-serif",
    fontSize: 12,
    lineHeight: 1.55,
    color: ink
  } }, /* @__PURE__ */ React.createElement("span", { style: {
    display: "inline-block",
    padding: "2px 7px",
    marginRight: 10,
    background: "var(--saffron, #E8AB30)",
    color: ink,
    fontSize: 10,
    fontWeight: 600,
    letterSpacing: "0.18em",
    textTransform: "uppercase",
    verticalAlign: "middle"
  } }, "Preview"), /* @__PURE__ */ React.createElement("span", { style: { verticalAlign: "middle" } }, "This is a fast preview render. The final printed plate uses a finer pipeline (cleaner water bodies, engraved roads). Catalogue cities (Sheffield, Cambridge, Durham\u2026) already show the finished look.")) : null, /* @__PURE__ */ React.createElement("div", { style: { display: "flex", flexDirection: "column", gap: 12 } }, cartError ? /* @__PURE__ */ React.createElement("div", { style: {
    padding: "12px 16px",
    background: "rgba(211, 72, 51, 0.08)",
    border: "1px solid var(--vermilion, #D34833)",
    color: "var(--vermilion, #D34833)",
    fontFamily: "Inter, sans-serif",
    fontSize: 13
  } }, cartError) : null, /* @__PURE__ */ React.createElement("button", { onClick: handleAddToCart, disabled: cartBusy || !variantId, style: {
    padding: "18px 28px",
    cursor: cartBusy || !variantId ? "not-allowed" : "pointer",
    background: cartBusy ? stone : ink,
    color: bone,
    border: "1px solid " + ink,
    fontFamily: "Inter, sans-serif",
    fontSize: 13,
    fontWeight: 600,
    letterSpacing: "0.22em",
    textTransform: "uppercase"
  } }, cartBusy ? "Adding\u2026" : !variantId ? "Configure picker (no variant)" : `Add to cart \xB7 ${price || "\xA345"}`), /* @__PURE__ */ React.createElement("div", { style: { fontSize: 11, color: stone, textAlign: "center", lineHeight: 1.5 } }, "Made to order. Ships within 7 working days via Royal Mail Tracked 48."), /* @__PURE__ */ React.createElement("div", { style: { fontSize: 11, color: stone, textAlign: "center", lineHeight: 1.5 } }, "We preview every kilometre before printing. If yours can\u2019t be produced, you\u2019ll hear within 48 hours \u2014 full refund, or the nearest workable square.")));
}
function PreviewCard({ tile, assets, labelDefaults, fallbackImage, label, ink, bone, stone, line }) {
  return /* @__PURE__ */ React.createElement("div", { style: { border: "1px solid " + line, padding: 12, background: bone } }, /* @__PURE__ */ React.createElement("div", { style: { fontSize: 10, letterSpacing: "0.32em", textTransform: "uppercase", color: stone, marginBottom: 8 } }, label), /* @__PURE__ */ React.createElement("div", { style: { position: "relative", aspectRatio: "1 / 1", border: "1px solid " + ink, background: bone, overflow: "hidden" } }, window.Model3DViewer ? /* @__PURE__ */ React.createElement(
    window.Model3DViewer,
    {
      url: assets.glb,
      fallback: fallbackImage,
      label: labelDefaults ? { title: labelDefaults.title, subline: labelDefaults.subline, coord: labelDefaults.coords, showCoords: labelDefaults.showCoords !== false } : { title: assets.title, subline: assets.subline, coord: assets.coord, showCoords: true },
      height: "100%",
      autoRotate: true,
      autoRotateSpeed: -0.6
    }
  ) : null), /* @__PURE__ */ React.createElement("div", { style: { marginTop: 8, fontSize: 12, color: ink, fontWeight: 600 } }, tile.place, tile.locality ? " \xB7 " + tile.locality : ""), /* @__PURE__ */ React.createElement("div", { style: { fontSize: 10, color: stone, letterSpacing: "0.16em", textTransform: "uppercase" } }, tile.tileId, " \xB7 ", assets.coord));
}
function RecentOrders({ allTiles, tileById, onSelectTile, ink, bone, stone, line }) {
  const recent = React.useMemo(() => {
    const picks = [
      "SK3587",
      "NZ2742",
      "SE6051",
      "TA0928",
      "TQ3779",
      "NZ8911",
      "SJ8398",
      "TL4457",
      "NT2473",
      "SP0687",
      "SK3486",
      "SK3489"
    ];
    return picks.map((id) => tileById.get(id)).filter(Boolean).slice(0, 8);
  }, [tileById]);
  const ranks = ["today", "today", "yesterday", "2 days ago", "3 days ago", "this week", "this week", "this week"];
  if (!recent.length) return null;
  return /* @__PURE__ */ React.createElement("div", { style: { padding: "12px 24px 32px", maxWidth: 1280, margin: "0 auto" } }, /* @__PURE__ */ React.createElement("div", { style: { fontSize: 10, letterSpacing: "0.32em", textTransform: "uppercase", color: stone, marginBottom: 10 } }, "Recently commissioned"), /* @__PURE__ */ React.createElement("div", { style: { display: "flex", overflowX: "auto", gap: 12, paddingBottom: 6, scrollbarWidth: "thin" } }, recent.map((t, i) => /* @__PURE__ */ React.createElement("button", { key: t.tileId, onClick: () => onSelectTile(t), style: {
    flex: "0 0 220px",
    padding: "14px 16px",
    textAlign: "left",
    border: "1px solid " + line,
    background: bone,
    cursor: "pointer"
  } }, /* @__PURE__ */ React.createElement("div", { style: { fontSize: 13, fontWeight: 600, color: ink } }, t.place, t.locality ? " \xB7 " + t.locality : ""), /* @__PURE__ */ React.createElement("div", { style: { fontSize: 11, color: stone, marginTop: 4, letterSpacing: "0.14em", textTransform: "uppercase" } }, "ordered ", ranks[i] || "this week")))));
}
function FaqBlock({ openIdx, setOpenIdx, ink, stone, line }) {
  const items = [
    {
      q: "What's included for \xA345?",
      a: "A 9 \xD7 9 cm 3D-printed plate of a 1 km square in England, Wales or most of Scotland, on a black or white base (your choice \u2014 both free), with a stainless-steel laser-engraved label carrying the city + coordinates. Free UK shipping. No add-on fees on the standard engraving."
    },
    {
      q: "How long does it take to arrive?",
      a: "English areas ship within 7 working days. Welsh and Scottish areas take ~14 working days because we fetch the LIDAR from a different government source. Tracked UK delivery from then."
    },
    {
      q: "What if you can't print my kilometre?",
      a: "It happens \u2014 Britain's LIDAR has gaps, especially near the edges of Scottish coverage, and a few squares come back as flat water or fail at the tile boundary. Every order goes through a preview check before we start printing. If yours can't be produced to spec, you'll hear within 48 hours, and we'll either refund in full or offer the nearest workable kilometre \u2014 your call."
    },
    {
      q: "What's it made of?",
      a: "Matte PLA (corn-based bioplastic) for both the city plate and the black base. The engraved label is a separate stainless-steel plate, laser-marked with your text and seated into a slot on the base."
    },
    {
      q: "Can I personalise the engraving?",
      a: 'Yes \u2014 click "Personalise the engraving" after picking your kilometre. You can replace the default city + coordinates with any text (up to 14 characters per line with coords shown, more without). Personalisation is +\xA33 to cover the bespoke laser run.'
    },
    {
      q: "What if my exact street isn't in the picker?",
      a: `Email studio@cityform.co.uk with a postcode, a what3words, or just a description ("around the canal in Sheffield"). We'll bake a preview within 48 hours \u2014 no obligation.`
    }
  ];
  return /* @__PURE__ */ React.createElement("div", { style: { padding: "0 24px 64px", maxWidth: 880, margin: "0 auto" } }, /* @__PURE__ */ React.createElement("div", { style: { fontSize: 10, letterSpacing: "0.32em", textTransform: "uppercase", color: stone, marginBottom: 16 } }, "Questions"), items.map((it, idx) => {
    const open = openIdx === idx;
    return /* @__PURE__ */ React.createElement("div", { key: idx, style: { borderTop: "1px solid " + line, padding: "14px 0" } }, /* @__PURE__ */ React.createElement("button", { onClick: () => setOpenIdx(open ? -1 : idx), style: {
      width: "100%",
      textAlign: "left",
      padding: 0,
      cursor: "pointer",
      border: "none",
      background: "transparent",
      display: "flex",
      justifyContent: "space-between",
      alignItems: "baseline",
      gap: 16,
      fontFamily: "Inter, sans-serif",
      color: ink,
      fontSize: 15,
      fontWeight: 500
    } }, /* @__PURE__ */ React.createElement("span", null, it.q), /* @__PURE__ */ React.createElement("span", { style: { color: stone, fontSize: 18 } }, open ? "\u2013" : "+")), open ? /* @__PURE__ */ React.createElement("p", { style: {
      margin: "10px 0 0",
      color: stone,
      fontSize: 14,
      lineHeight: 1.6,
      maxWidth: 640
    } }, it.a) : null);
  }));
}
function MobileStickyCta({ price, cartBusy, handleAddToCart, ink, bone }) {
  return /* @__PURE__ */ React.createElement("div", { className: "cf-picker-mobile-cta", style: {
    position: "fixed",
    left: 0,
    right: 0,
    bottom: 0,
    background: ink,
    color: bone,
    padding: "12px 16px",
    display: "none",
    /* CSS flips to flex at <=720px (see <style> in liquid) */
    alignItems: "center",
    justifyContent: "space-between",
    gap: 12,
    zIndex: 50,
    boxShadow: "0 -8px 24px rgba(0,0,0,0.18)"
  } }, /* @__PURE__ */ React.createElement("span", { style: { fontSize: 12, letterSpacing: "0.18em", textTransform: "uppercase", fontWeight: 600 } }, price || "\xA345", " \xB7 ships 7 days"), /* @__PURE__ */ React.createElement("button", { onClick: handleAddToCart, disabled: cartBusy, style: {
    padding: "12px 18px",
    cursor: cartBusy ? "wait" : "pointer",
    background: bone,
    color: ink,
    border: "none",
    fontFamily: "Inter, sans-serif",
    fontSize: 11,
    fontWeight: 700,
    letterSpacing: "0.22em",
    textTransform: "uppercase"
  } }, cartBusy ? "Adding\u2026" : "Add to cart"));
}
Object.assign(window, { CfTilePicker });
window.BaseColorSelector = BaseColorSelector;
window.CfTilePicker = CfTilePicker;
window.ComingSoonNotice = ComingSoonNotice;
window.EmptyPreview = EmptyPreview;
window.FaqBlock = FaqBlock;
window.FilterChip = FilterChip;
window.MobileStickyCta = MobileStickyCta;
window.PreviewCard = PreviewCard;
window.RecentOrders = RecentOrders;
window.SearchTabs = SearchTabs;
window.SelectedTilePane = SelectedTilePane;
window.SpecStrip = SpecStrip;
})();
